import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import {
  ACTION_LOAD_BALANCE_SUMMARY__REQUEST,
  ACTION_LOAD_BALANCE_SUMMARY__SUCCESS,
  ACTION_LOAD_BALANCE_SUMMARY__FAIL,
} from '../actionTypes';


const actionLoadBalanceSummarySuccess = result => ({
  type: ACTION_LOAD_BALANCE_SUMMARY__SUCCESS,
  payload: { result },
});

const actionLoadBalanceSummaryFail = error => ({
  type: ACTION_LOAD_BALANCE_SUMMARY__FAIL,
  payload: { error },
});

export const actionLoadBalanceSummaryRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_BALANCE_SUMMARY__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/webmaster/balance/summary'
    ).then(
      result => {
        dispatch(actionLoadBalanceSummarySuccess(result));
      },
      error => {
        dispatch(actionLoadBalanceSummaryFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
